import styled from 'styled-components';

export const Badge = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 3px;
    fill: ${p => p.theme.colors.positive500};
  }
`;

export const Text = styled.div`
  margin: 5px;
  line-height: 1.3em;
`;

export const RelatedReviews = styled.span`
  margin-left: 10px;
  color: ${props => props.theme.text.secondary};
`;
